import CreditCardFormValidation from '../entrypoints/src/admin/components/credit_card_form_validation';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.bindEvents();
    this.initCreditCardFormValidation();
  }

  bindEvents() {
    $('#payment-profile').on('show.bs.collapse', (ev) => {
      let radio = ev.target.closest('.card').querySelector('input[type="radio"]');
      !!radio && (radio.checked = true);
    });
  }

  initCreditCardFormValidation() {
    let _this = this;
    let unknownBrand = this.element.querySelector('[data-card-brand="unknown"]');

    this.formValidation = new CreditCardFormValidation(this.element, {
      afterValidate(valid) { /***/ },
      onCardTypeChanged({type, creditCard}) {
        unknownBrand.classList.toggle('hidden', false);
        _this.element.querySelectorAll(`[data-card-brand]`).forEach((el) => { el.classList.toggle('hidden', true) });

        let brandType = !!type ? type : !!creditCard ? creditCard.card.type : 'unknown',
          brand = _this.element.querySelector(`[data-card-brand="${brandType.replace(/[-]/, '')}"]`);

        if (!brand)
          return true;

        unknownBrand.classList.toggle('hidden', true);
        brand.classList.toggle('hidden', false);
      }
    });
  }
}